export default __webpack_public_path__ + "static/usa_arkansas_state_jackpot-d51fc850af1b201fa97119b41ee769cb.png";